import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { HttpClient } from '@angular/common/http';
import { VizCommonModule } from '../common/common.module';
import {
  CompareWithMixin,
  EmptyObject
} from '../common/utils';
import { TBooking } from '../core/entities';
import { SessionCache } from '../session.cache';
import { BookingMixin } from '../thinkdesks/booking.mixin';

@Component({
  selector: 'app-booking-select-dialog',
  templateUrl: './booking.select.dialog.html',
  standalone: true,

  imports: [
    CommonModule,
    MatSelectModule,
    FontAwesomeModule,
    MatDialogModule,
    VizCommonModule,
  ],
})
export class BookingSelectDialog extends CompareWithMixin(BookingMixin(EmptyObject)) {
  _common = _common;


  objects: TBooking[] = [];

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private cache: SessionCache,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<BookingSelectDialog>
  ) {
    super();
    this.objects = this.data.objects;
  }


  cancel() {
    this.dialogRef.close();
  }
  closeDialog() {
    this.dialogRef.close();
  }
  open(s: any) {
    this.dialogRef.close(s);
  }

}
